import clsx from "clsx";
import React from "react";

interface EmptyResourceDisplayProps {
    isCompact: boolean;
    needsResourceAssignment: boolean;
}

export const EmptyResourceDisplay = ({ isCompact, needsResourceAssignment }: EmptyResourceDisplayProps) => (
    <span
        className={clsx(
            isCompact ? "inline-block" : "w-24 truncate xl:w-28 2xl:w-32",
            isCompact && !needsResourceAssignment && "pl-1",
        )}
    />
);
